/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCustomSacCalculatorViewProps } from '../../../modules/hosports-custom-sac-calculator/./hosports-custom-sac-calculator';
// @ts-ignore
import CustomSacCalculator from "./../../../baseComponents/sac-calculator/./sac-calculator";

interface IState {
  ready:boolean;
}

/**
 *
 * Parallax Loose Grid component
 * @extends {React.Component<IHosportsVideoBoxViewProps>}
 */
class HosportsCustomSacCalculator extends React.Component<IHosportsCustomSacCalculatorViewProps,IState> {

  public state: IState;

  constructor(props: IHosportsCustomSacCalculatorViewProps) {
    super(props);
    this.state = {
      ready:true
    };
  }

  public render(): JSX.Element {
    const { config } = this.props;
      return (
      <CustomSacCalculator
        year={config.year}
        />
    );
  }
}

export default HosportsCustomSacCalculator;
